<div class="chat-container">
  <ng-container *ngFor="let item of groupedMessages">
    
    <!-- Date separator -->
    <div *ngIf="item.type === 'date'" class="date-separator">
      {{ item.date }}
    </div>
    
    <!-- Chat message -->
    <div *ngIf="item.type === 'message'" 
         class="chat-message" 
         [ngClass]="item.User.toLowerCase()">
         
      <div class="bubble">
        <div class="message-text">
          
          <!-- If attachment, show icon + file name -->
          <ng-container *ngIf="item.messageType === 'Attachment'; else normalMsg">
           <i class="fa fa-paperclip" aria-hidden="true"></i>
            {{ getFileName(item.Message) }}
          </ng-container>

          <!-- Normal message -->
          <ng-template #normalMsg>
            {{ item.Message }}
          </ng-template>

        </div>
        <div class="message-time">{{ getFormattedTime(item.SendTime) }}</div>
      </div>
    </div>

  </ng-container>
</div>
